
import 'react-app-polyfill/ie11'; // This needs to come VERY FIRST as per CRA documentation
import 'babel-polyfill'; // This needs to come SECOND so ES6 polyfills will be available in ES5 browsers
import 'airbnb-browser-shims/document-contains'; // This should come THIRD

import { BugsnagErrorBoundary as AppErrorBoundary } from 'services/bugsnag';
import React from 'react';
import { render as ReactDOMRender } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import ThemeProvider from 'modsy-ui-kit/build/ThemeProvider';

import analytics from './services/analytics';
import AppHelmet from './shared/components/AppHelmet';
import AppNotifications from './shared/components/AppNotifications';
import configureStore from './config/store/configureStore';
import history from './config/history';
import './fonts/Graphik/fonts.css';
import './fonts/Lora/fonts.css';
import 'web-ui-kit/fonts/GeorgiaPro/fonts.css';
import 'web-ui-kit/fonts/ProximaNova/fonts.css';

import loadFonts from './utils/loadFonts';

const MOUNT_NODE = document.getElementById('root');
const store = configureStore(window.__INITIAL_STATE__);

// Put the store on window object so we can run
// Google Optimize experiments by simply dispatching
// actions on the store inside experiment configuration.
// Also, we rely on this for appending user data to bugsnag error reports.
window.modsyStore = store;

// Track pageviews for analytics and scroll to
// top of page whenever a new location loads.
history.listen(location => {
  analytics.trackPageView({ location, isInitialPageLoad: false })();

  // Opt out of automatic scroll to top on url change.
  if (location.state && location.state.doNotScrollTop) { return; }

  // Scroll to top of viewport.
  window.scrollTo(0, 0);
});

window.addEventListener(
  'experimentAssignment',
  event => {
    const experiment = event.detail;
    if (experiment) {
      const type = experiment.name;
      const payload = experiment.treatment;
      if (type && payload) {
        store.dispatch({ type, payload });
      }
    }
  },
  false
);

const render = () => {
  const App = require('./screens/App/App.js').default;

  ReactDOMRender(
    <AppErrorBoundary>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <ThemeProvider>
            <AppHelmet />
            <App />
            <AppNotifications />
          </ThemeProvider>
        </ConnectedRouter>
      </Provider>
    </AppErrorBoundary>,
    MOUNT_NODE
  );
};

if (module.hot) {
  module.hot.accept(require.resolve('./screens/App/App.js'), () => {
    console.log('Hot reloading App component!');
    render();
  });
}

render();
loadFonts();
